module.exports = __webpack_public_path__ + "static/media/que-hacer-en-tigre.24cbacf9.md";